import React from 'react'

import PelaksanaanObservasi from 'app/KinerjaPage/pages/PelaksanaanV2/Beranda/PelaksanaanObservasi'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const PelaksanaanObservasiPage = () => {
  return (
    <KinerjaTipeProvider tipe="SPF">
      <PageGuardPelaksanaanDate>
        <PelaksanaanObservasi />
      </PageGuardPelaksanaanDate>
    </KinerjaTipeProvider>
  )
}

PelaksanaanObservasiPage.Layout = KinerjaLayout

PelaksanaanObservasiPage.layoutOpts = {
  hasHeader: true,
}

export default PelaksanaanObservasiPage
